"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTime = void 0;
exports.parseFissionStatusRules = parseFissionStatusRules;
exports.getFissionStatusContent = getFissionStatusContent;
exports.defineFegoVariable = defineFegoVariable;
exports.hasDefineFegoVariable = hasDefineFegoVariable;
const constants_1 = require("./constants");
/** 将编辑器中的状态配置解析为规则列表 */
function parseFissionStatusRules(statusList) {
    return statusList.map((item) => ({
        actionIds: item.actionIds.split(',').map(Number),
        content: item.content
    }));
}
/**
 * 解析列表行右侧展示的 HTML：
 * 1. 开启展示过期且行已失效 → 过期富文本
 * 2. 开启 Push 且配置了合法 actionId、且受邀人未完成该动作 → 按 canRemind 展示可发/不可发 Push 富文本（与 getFissionList + remindInvitee 语义一致）
 * 3. 其余 → 按动作状态配置匹配默认/状态列表
 */
function getFissionStatusContent(params) {
    const { item, rules, config, defaultStatusContent } = params;
    const result = {
        content: defaultStatusContent || '',
        styleType: constants_1.LIST_STYLE_DEFAULT
    };
    // 1. 开启展示过期且行已失效 → 过期富文本
    if (config.showExpired && item.bindStatus === constants_1.BIND_STATUS_INVALID) {
        result.content = config.expiredStateContent || '';
        result.styleType = constants_1.LIST_STYLE_EXPIRED;
        return result;
    }
    // 2. 是否有符合的状态配置
    for (const statusItem of rules) {
        if (statusItem.actionIds.every((id) => item.actionIds.includes(id))) {
            result.content = statusItem.content;
            return result;
        }
    }
    // 3. 是否有符合的 Push 配置
    const pushActionId = Number(config.pushDefaultActionId);
    if (config.needPush && pushActionId > 0) {
        result.content = (item.canRemind ? config.pushAvailableContent : config.pushUnavailableContent) || '';
        result.styleType = item.canRemind ? constants_1.LIST_STYLE_PUSH_AVAILABLE : constants_1.LIST_STYLE_PUSH_UNAVAILABLE;
        return result;
    }
    // 4. 默认返回
    return result;
}
const formatTime = (timestamp) => {
    if (!timestamp) {
        return '';
    }
    // 处理秒级和毫秒级时间戳（10位和13位）
    const isSecondTimestamp = timestamp.toString().length === constants_1.TIMESTAMP_SECOND_LENGTH;
    const time = isSecondTimestamp ? timestamp * constants_1.TIMESTAMP_MILLISECOND : timestamp;
    const date = new Date(time);
    // 检查日期是否合法
    if (isNaN(date.getTime())) {
        return '';
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(constants_1.PAD_LENGTH, '0');
    const day = String(date.getDate()).padStart(constants_1.PAD_LENGTH, '0');
    const hours = String(date.getHours()).padStart(constants_1.PAD_LENGTH, '0');
    const minutes = String(date.getMinutes()).padStart(constants_1.PAD_LENGTH, '0');
    return `${year}/${month}/${day} ${hours}:${minutes}`;
};
exports.formatTime = formatTime;
/**
 * 定义fego变量
 * @param key fego变量名
 * @param value fego变量值
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function defineFegoVariable(key, value) {
    const editor = require('@futuweb/fego-editor');
    editor.app.project.setVariable(Object.assign(editor.app.project.variable, {
        [key]: value
    }));
}
/**
 * 判断fego变量是否定义
 * @param key fego变量名
 * @returns {boolean} 是否定义
 */
function hasDefineFegoVariable(key) {
    const editor = require('@futuweb/fego-editor');
    return editor.app.project.variable[key] !== undefined;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ1dGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUE2QkEsMERBS0M7QUFRRCwwREFrQ0M7QUErQkQsZ0RBT0M7QUFPRCxzREFHQztBQTVIRCwyQ0FTcUI7QUFtQnJCLHdCQUF3QjtBQUN4QixTQUFnQix1QkFBdUIsQ0FBQyxVQUFvRDtJQUN4RixPQUFPLFVBQVUsQ0FBQyxHQUFHLENBQUMsQ0FBQyxJQUFJLEVBQUUsRUFBRSxDQUFDLENBQUM7UUFDN0IsU0FBUyxFQUFFLElBQUksQ0FBQyxTQUFTLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxNQUFNLENBQUM7UUFDaEQsT0FBTyxFQUFFLElBQUksQ0FBQyxPQUFPO0tBQ3hCLENBQUMsQ0FBQyxDQUFDO0FBQ1IsQ0FBQztBQUVEOzs7OztHQUtHO0FBQ0gsU0FBZ0IsdUJBQXVCLENBQUMsTUFLdkM7SUFDRyxNQUFNLEVBQUUsSUFBSSxFQUFFLEtBQUssRUFBRSxNQUFNLEVBQUUsb0JBQW9CLEVBQUUsR0FBRyxNQUFNLENBQUM7SUFDN0QsTUFBTSxNQUFNLEdBQUc7UUFDWCxPQUFPLEVBQUUsb0JBQW9CLElBQUksRUFBRTtRQUNuQyxTQUFTLEVBQUUsOEJBQWtCO0tBQ2hDLENBQUM7SUFDRix5QkFBeUI7SUFDekIsSUFBSSxNQUFNLENBQUMsV0FBVyxJQUFJLElBQUksQ0FBQyxVQUFVLEtBQUssK0JBQW1CLEVBQUUsQ0FBQztRQUNoRSxNQUFNLENBQUMsT0FBTyxHQUFHLE1BQU0sQ0FBQyxtQkFBbUIsSUFBSSxFQUFFLENBQUM7UUFDbEQsTUFBTSxDQUFDLFNBQVMsR0FBRyw4QkFBa0IsQ0FBQztRQUN0QyxPQUFPLE1BQU0sQ0FBQztJQUNsQixDQUFDO0lBQ0QsZ0JBQWdCO0lBQ2hCLEtBQUssTUFBTSxVQUFVLElBQUksS0FBSyxFQUFFLENBQUM7UUFDN0IsSUFBSSxVQUFVLENBQUMsU0FBUyxDQUFDLEtBQUssQ0FBQyxDQUFDLEVBQUUsRUFBRSxFQUFFLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxRQUFRLENBQUMsRUFBRSxDQUFDLENBQUMsRUFBRSxDQUFDO1lBQ2xFLE1BQU0sQ0FBQyxPQUFPLEdBQUcsVUFBVSxDQUFDLE9BQU8sQ0FBQztZQUNwQyxPQUFPLE1BQU0sQ0FBQztRQUNsQixDQUFDO0lBQ0wsQ0FBQztJQUNELG9CQUFvQjtJQUNwQixNQUFNLFlBQVksR0FBRyxNQUFNLENBQUMsTUFBTSxDQUFDLG1CQUFtQixDQUFDLENBQUM7SUFDeEQsSUFBSSxNQUFNLENBQUMsUUFBUSxJQUFJLFlBQVksR0FBRyxDQUFDLEVBQUUsQ0FBQztRQUN0QyxNQUFNLENBQUMsT0FBTyxHQUFHLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLG9CQUFvQixDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsc0JBQXNCLENBQUMsSUFBSSxFQUFFLENBQUM7UUFDdEcsTUFBTSxDQUFDLFNBQVMsR0FBRyxJQUFJLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxxQ0FBeUIsQ0FBQyxDQUFDLENBQUMsdUNBQTJCLENBQUM7UUFDNUYsT0FBTyxNQUFNLENBQUM7SUFDbEIsQ0FBQztJQUVELFVBQVU7SUFDVixPQUFPLE1BQU0sQ0FBQztBQUNsQixDQUFDO0FBRU0sTUFBTSxVQUFVLEdBQUcsQ0FBQyxTQUFpQixFQUFFLEVBQUU7SUFDNUMsSUFBSSxDQUFDLFNBQVMsRUFBRSxDQUFDO1FBQ2IsT0FBTyxFQUFFLENBQUM7SUFDZCxDQUFDO0lBQ0QsdUJBQXVCO0lBQ3ZCLE1BQU0saUJBQWlCLEdBQUcsU0FBUyxDQUFDLFFBQVEsRUFBRSxDQUFDLE1BQU0sS0FBSyxtQ0FBdUIsQ0FBQztJQUNsRixNQUFNLElBQUksR0FBRyxpQkFBaUIsQ0FBQyxDQUFDLENBQUMsU0FBUyxHQUFHLGlDQUFxQixDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUM7SUFDL0UsTUFBTSxJQUFJLEdBQUcsSUFBSSxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7SUFFNUIsV0FBVztJQUNYLElBQUksS0FBSyxDQUFDLElBQUksQ0FBQyxPQUFPLEVBQUUsQ0FBQyxFQUFFLENBQUM7UUFDeEIsT0FBTyxFQUFFLENBQUM7SUFDZCxDQUFDO0lBRUQsTUFBTSxJQUFJLEdBQUcsSUFBSSxDQUFDLFdBQVcsRUFBRSxDQUFDO0lBQ2hDLE1BQU0sS0FBSyxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsUUFBUSxFQUFFLEdBQUcsQ0FBQyxDQUFDLENBQUMsUUFBUSxDQUFDLHNCQUFVLEVBQUUsR0FBRyxDQUFDLENBQUM7SUFDcEUsTUFBTSxHQUFHLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxPQUFPLEVBQUUsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxzQkFBVSxFQUFFLEdBQUcsQ0FBQyxDQUFDO0lBQzdELE1BQU0sS0FBSyxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsUUFBUSxFQUFFLENBQUMsQ0FBQyxRQUFRLENBQUMsc0JBQVUsRUFBRSxHQUFHLENBQUMsQ0FBQztJQUNoRSxNQUFNLE9BQU8sR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLFVBQVUsRUFBRSxDQUFDLENBQUMsUUFBUSxDQUFDLHNCQUFVLEVBQUUsR0FBRyxDQUFDLENBQUM7SUFFcEUsT0FBTyxHQUFHLElBQUksSUFBSSxLQUFLLElBQUksR0FBRyxJQUFJLEtBQUssSUFBSSxPQUFPLEVBQUUsQ0FBQztBQUN6RCxDQUFDLENBQUM7QUFyQlcsUUFBQSxVQUFVLGNBcUJyQjtBQUVGOzs7O0dBSUc7QUFDSCw4REFBOEQ7QUFDOUQsU0FBZ0Isa0JBQWtCLENBQUMsR0FBVyxFQUFFLEtBQVU7SUFDdEQsTUFBTSxNQUFNLEdBQUcsT0FBTyxDQUFDLHNCQUFzQixDQUFDLENBQUM7SUFDL0MsTUFBTSxDQUFDLEdBQUcsQ0FBQyxPQUFPLENBQUMsV0FBVyxDQUMxQixNQUFNLENBQUMsTUFBTSxDQUFDLE1BQU0sQ0FBQyxHQUFHLENBQUMsT0FBTyxDQUFDLFFBQVEsRUFBRTtRQUN2QyxDQUFDLEdBQUcsQ0FBQyxFQUFFLEtBQUs7S0FDZixDQUFDLENBQ0wsQ0FBQztBQUNOLENBQUM7QUFFRDs7OztHQUlHO0FBQ0gsU0FBZ0IscUJBQXFCLENBQUMsR0FBVztJQUM3QyxNQUFNLE1BQU0sR0FBRyxPQUFPLENBQUMsc0JBQXNCLENBQUMsQ0FBQztJQUMvQyxPQUFPLE1BQU0sQ0FBQyxHQUFHLENBQUMsT0FBTyxDQUFDLFFBQVEsQ0FBQyxHQUFHLENBQUMsS0FBSyxTQUFTLENBQUM7QUFDMUQsQ0FBQyJ9